export const mockData = {
  hero: {
    title: ["Securing", "Critical", "Infrastructure"],
    subtitle: "Operational Technology Engineering & Cybersecurity Excellence",
    cta: "Secure Your Operations",
    stats: [
      { number: "6", label: "Countries" },
      { number: "26", label: "Years of Collective Experience" },
      { number: "56+", label: "Projects" },
      { number: "0", label: "Near Misses Since 2024" }
    ]
  },
  services: [
    {
      number: "01",
      title: "Design",
      description: "We provide comprehensive design services, creating a detailed blueprint for your automation system, including hardware specifications, software architecture, network design, and safety considerations, tailored to your specific requirements.",
      features: [
        "Hardware Specifications",
        "Software Architecture",
        "Network Design",
        "Safety Considerations"
      ]
    },
    {
      number: "02",
      title: "Integration",
      description: "We specialize in integrating your automation systems with existing infrastructure, including legacy systems, MES/ERP platforms, and other automation components, ensuring seamless data flow and optimized performance.",
      features: [
        "Legacy System Integration",
        "MES/ERP Platforms",
        "Automation Components",
        "Seamless Data Flow"
      ]
    },
    {
      number: "03",
      title: "Operations",
      description: "We offer operational support and optimization services for your automated systems, including performance monitoring, troubleshooting, and continuous improvement initiatives, maximizing efficiency and productivity.",
      features: [
        "Performance Monitoring",
        "Troubleshooting",
        "Continuous Improvement",
        "Efficiency Optimization"
      ]
    },
    {
      number: "04",
      title: "Engineering",
      description: "Our engineering services cover the full lifecycle of your automation project, from design and development to implementation and commissioning, ensuring seamless integration, optimal performance, and adherence to industry standards.",
      features: [
        "Full Lifecycle Support",
        "Development & Implementation",
        "Commissioning",
        "Industry Standards Compliance"
      ]
    },
    {
      number: "05",
      title: "Risk Management",
      description: "Our risk management services identify and mitigate potential hazards throughout the automation lifecycle, from design and implementation to operation and maintenance, ensuring a safe and reliable working environment - with emphasis on cyber attack vectors.",
      features: [
        "Hazard Identification",
        "Cyber Attack Vector Analysis",
        "Risk Mitigation Strategies",
        "Safety Compliance"
      ]
    },
    {
      number: "06",
      title: "Maintenance",
      description: "Our maintenance services ensure the long-term reliability and performance of your automation systems, including preventative maintenance, repairs, and upgrades, minimizing downtime and maximizing your return on investment.",
      features: [
        "Preventative Maintenance",
        "Repairs & Upgrades",
        "Downtime Minimization",
        "Long-term Reliability"
      ]
    }
  ],
  about: {
    title: "Engineering Resilience Into Every Layer",
    paragraphs: [
      "OT Resilience stands at the intersection of operational technology and cybersecurity. We understand that critical infrastructure demands more than standard IT security—it requires specialized expertise, proven methodologies, and an unwavering commitment to operational continuity.",
      "Our team of certified engineers and security professionals brings decades of combined experience protecting power generation facilities, manufacturing plants, water treatment systems, and transportation networks. We don't just secure systems; we engineer resilience into every layer of your operations.",
      "From initial assessment to ongoing monitoring, we partner with organizations to build robust security programs that protect critical assets while enabling business growth."
    ],
    principles: [
      { title: "Secure", description: "Defense-in-depth strategies for OT environments" },
      { title: "Sustain", description: "Continuous monitoring and adaptive protection" },
      { title: "Automate", description: "Intelligent systems for proactive threat response" }
    ]
  },
  contact: {
    title: "Let's Secure Your Critical Infrastructure",
    subtitle: "Ready to strengthen your operational technology security? Our team is here to help. Contact us today for a no-obligation quote.",
    email: "info@otresilience.com",
    phone: "+1-917-695-2027",
    location: "Ajman, UAE"
  },
  marquee: {
    text: "SECURE. SUSTAIN. AUTOMATE."
  }
};
